import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=c0d41838&scoped=true"
import script from "./BookingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookingPage.vue?vue&type=style&index=0&id=c0d41838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d41838",
  null
  
)

export default component.exports